'use client'

// src/constants/age.ts
var MIN_AGE_ALLOWED = 13;
var MAX_AGE_ALLOWED = 100;

export {
  MIN_AGE_ALLOWED,
  MAX_AGE_ALLOWED
};
//# sourceMappingURL=chunk-Z6DGEBFH.mjs.map